import { $api } from "../AxiosInstance";

export class GoalService {
  static async goalGetAll() {
    return await $api.get("/api/admin/project/all");
  }

  static async goalGet(id) {
    return await $api.get("/api/admin/project", { params: { id } });
  }

  static async goalDelete(id) {
    return await $api.delete("/api/admin/project", { params: { id } });
  }

  static async goalSave(id, name, code) {
    return await $api.post("/api/admin/project", { id, name, code });
  }

  static async goalCreate(name, code) {
    return await $api.put("/api/admin/project", { name, code });
  }

  static async goalGroupGetAll() {
    return await $api.get("/api/admin/project/group/all");
  }

  static async goalGroupGet(id) {
    return await $api.get("/api/admin/project/group", { params: { id } });
  }

  static async goalGroupDelete(id) {
    return await $api.delete("/api/admin/project/group", { params: { id } });
  }

  static async goalGroupSave(id, name, code, localeCode, showOnFront) {
    return await $api.post("/api/admin/project/group", {
      id,
      name,
      code,
      localeCode,
      showOnFront,
    });
  }

  static async goalGroupCreate(name, code, localeCode) {
    return await $api.put("/api/admin/project/group", { name, code, localeCode });
  }

  static async getViewsByProjectId(projectId) {
    return await $api.get("/api/admin/projectView/byProjectId", {
      params: { projectId },
    });
  }

  static async getViewById(id) {
    return await $api.get("/api/admin/projectView", { params: { id } });
  }

  static async saveView(id, projectId, displayName, searchCriteria) {
    return await $api.post("/api/admin/projectView", {
      id,
      projectId,
      displayName,
      searchCriteria,
    });
  }

  static async deleteView(id) {
    return await $api.delete("/api/admin/projectView", { params: { id } });
  }

  static async createView(projectId, displayName, searchCriteria) {
    return await $api.put("/api/admin/projectView", {
      projectId,
      displayName,
      searchCriteria,
    });
  }

  static async getAllCustomProjects() {
    return await $api.get("/api/admin/customProject/all");
  }

  static async deleteCustomProjectById(id) {
    return await $api.delete("/api/admin/customProject", { params: { id } });
  }
}
